export var MAX_DEGREE = 160;
export var _smoothness = {
    1: 0.1,
    2: 0.02,
    3: 0.001,
    4: 0.0005,
    5: 0.0002,
};
